// The large brand lockup the signed-out screens carry in place of the header.
//
// The signed-out screens render no chrome at all (see BARE_PATHS in chrome.ts),
// so this is the only logo on them — and it is a LINK for the same reason the
// header's `.brand` is: a visitor who taps "Create an account" and changes
// their mind has no other way back. Signed out, `/` bounces to /login (see
// PUBLIC_PATHS in main.ts), which is exactly the start they want; on SocialTie
// `/` is its own public home.
//
// One helper rather than seven copies, because it had already drifted: privacy,
// terms and contact wrapped the image in an anchor and login and register did
// not. It also resolves the brand, so the SocialTie surface no longer shows the
// MySocialCal wordmark on its own login screen.

import { el } from '../dom.js';
import { brandLogo, brandName } from '../brand.js';

/**
 * The lockup, wrapped in a link home.
 *
 * `tag` is the element the lockup sits in: an `h1` where it IS the page's
 * heading (login, register), a plain `div` where the page has a real heading of
 * its own below it (privacy, terms, contact).
 */
export function authBrand(tag: 'h1' | 'div' = 'div'): HTMLElement {
  return el(tag, { class: 'auth-brand' }, [
    el('a', { href: '/', class: 'auth-brand-link' }, [
      el('img', { class: 'brand-logo brand-logo-lg', src: brandLogo(), alt: brandName() }),
    ]),
  ]);
}
